import { Card } from "@mui/material";
import React, { useMemo } from "react";
import Flx from "../layout/Flx";
import DashboardLogo from "../../assets/DashboardLogo";
import Htag from "../typography/Htag";
import Txt from "../typography/Txt";
import HandsomeHomebuyerLogo from "../../assets/HandsomeHomebuyerLogo";

const BrandedCard = ({
  width = 480,
  sx,
  title,
  description,
  partner,
  children,
}) => {
  const cardWidth = useMemo(() => width, [width]);
  const offset = useMemo(() => 100, []);

  return (
    <Card
      sx={{
        p: 4,
        py: 6,
        position: "relative",
        maxWidth: cardWidth,
        width: "100%",
        ...sx,
      }}
    >
      <Flx
        fw
        center
        column
        sx={{
          position: "relative",
          maxWidth: cardWidth - offset,
          width: "100%",
          margin: "0 auto",
        }}
      >
        <Flx fw center column gap={3} sx={{ mb: 4 }}>
          {/* <RenderedLogo partner={partner} /> */}
          <DashboardLogo width="155px" />
          <Flx center column gap={0.5}>
            <Htag h1>{title}</Htag>
            {description ? (
              <Txt sx={{ fontSize: "13px" }} center secondary>
                {description}
              </Txt>
            ) : null}
          </Flx>
        </Flx>

        {children}
      </Flx>
    </Card>
  );
};

const RenderedLogo = ({ partner }) => {
  if (partner === "handsome-homebuyer") {
    return <HandsomeHomebuyerLogo width="155px" />;
  }
  return <DashboardLogo width="115px" />;
};

export default BrandedCard;
